import { useFamilyBrandFilter } from '@modules/professional/hook/use-family-brand-filter';
import { ProfessionalBrandFamilyDropdown } from './ProfessionalBrandFamilyDropdown';

/**
 * Brand-family control above the Products grid (Figma 5526:100315).
 *
 * The dropdown is what pulls sister-brand products into the tab: the grid shows
 * this profile's own products until a visitor ticks a sibling. The same
 * selection also renders as a named group in the filter sidebar — both read
 * {@link useFamilyBrandFilter}, so the two can't disagree about what is on.
 *
 * The top-level categories used to sit beside it as a pill row. That put a
 * second band of pills directly under the profile's own tab pills: two rows of
 * the same control, one naming tabs and one naming categories, reading as a
 * single navigation that had gone wrong. The categories live in the filter
 * sidebar now, which is where the browse pages keep every other facet — the
 * browse pages make the opposite trade, listing categories in their pill bar
 * and leaving them out of the sidebar, because they have no tab bar to collide
 * with.
 */
export const ProfessionalProductsFilterBar = () => {
    const brandChips = useFamilyBrandFilter();

    if (brandChips.length === 0) return null;

    return (
        <div className="flex min-w-0 shrink-0 items-center gap-3">
            <ProfessionalBrandFamilyDropdown brands={brandChips} />
        </div>
    );
};
